import React, { forwardRef } from "react";
import classes from "./Input.module.css";

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  type: string;
}

const Input = forwardRef<HTMLInputElement, InputProps>(({ label, type, ...rest }, ref) => {
  return (
    <div className={classes.inputFieldContainer}>
      <label className="block font-medium mb-1">{label}</label><br />
      <input ref={ref} type={type} className={classes.inputField} {...rest} /> <br />
    </div>
  );
});

export default Input;
